import React from 'react'
import { Segment } from 'semantic-ui-react'
import { CustomFieldsGroup } from '@lk/api'
// @ts-ignore
import { Container, SegmentGroup } from 'shared/StyledComponents'

import DynamicFields from '../../DynamicFields'

const CustomFields = ({ data: { custfields, base } }) => (
  <Container>
    <SegmentGroup>
      <Segment.Group>
        <DynamicFields
          type={CustomFieldsGroup.Account}
          initialValues={custfields}
          form={`account-${base.ID}-customfields`}
        />
      </Segment.Group>
    </SegmentGroup>
  </Container>
)

CustomFields.defaultProps = {
  data: {},
}

export default CustomFields
